import { render, staticRenderFns } from "./LocomocaoVisitaCard.vue?vue&type=template&id=6cfa71f4&"
import script from "./LocomocaoVisitaCard.vue?vue&type=script&lang=js&"
export * from "./LocomocaoVisitaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports